import { useMutation } from '@tanstack/react-query'
import { requestRefill } from 'utils/api/treatments'

export function useRequestRefill() {
  return useMutation({
    mutationFn: (payload: { id: string; is_delivery: boolean }) =>
      requestRefill(payload.id, payload.is_delivery),
  })
}
